import { BasicAjaxAction } from "core/actions";
import { createError } from "core/exceptions";
import log from "loglevel";
import { call, debounce, put, takeLatest } from "redux-saga/effects";
import envconfig from "../envconfig";

function* basicApiCall(actionInstance, action) {
    const { payload } = action;
    try {
        const result = yield call(actionInstance.apiCall, payload);
        log.debug("result api call", result);
        yield put(actionInstance.success(result));
    } catch (e) {
        log.error(e);
        yield put(actionInstance.failed(null, createError(e)));
    }
}

export function createSagaBasicCall(actionInstance) {
    if (actionInstance.props.debounce) {
        const debounceSec = isNaN(actionInstance.props.debounce) ? envconfig.SEARCH_INPUT_DEBOUNCE_TIME : actionInstance.props.debounce;
        log.debug("calling basicAction with debounce ", actionInstance, debounceSec);
        try {
            return debounce(debounceSec, actionInstance.sendType, basicApiCall, actionInstance);
        } catch (error) {
            log.error(error);
        }
    }
    return takeLatest(actionInstance.sendType, basicApiCall, actionInstance);
}
export function createSagasForBasicCall(actionObj) {
    const arrayKey = Object.keys(actionObj);
    const actions = arrayKey.filter((k) => actionObj[k] instanceof BasicAjaxAction).map((k) => actionObj[k]);
    return actions.map((act) => createSagaBasicCall(act));
}
